export default __webpack_public_path__ + "assets/fonts/ROUNDS_BLACK.otf";